// Image Sizes For TMBD \\
export const img_300 = "https://image.tmdb.org/t/p/w300";
export const img_500 = "https://image.tmdb.org/t/p/w500";

// Backdrop Image \\
export const backdrop_img = "https://image.tmdb.org/t/p/original";

// Poster Not Available \\
export const posterUnavailable =
  "https://www.movienewz.com/img/films/poster-holder.jpg";

// No Picture \\
export const noPicture =
  "https://upload.wikimedia.org/wikipedia/en/6/60/No_Picture.jpg";
